/**
 * Maps logical field names to their column header variants across
 * FR/BE (French), PL (English), and future locales.
 *
 * Order matters: first match wins inside getColumn().
 */
export const COLUMN_MAPPING = {
  // Product identifiers
  asinParent:  ['ASIN (parent)', '(Parent) ASIN'],
  asinChild:   ['ASIN (enfant)', '(Enfant) ASIN', '(Child) ASIN'],
  title:       ['Titre', 'Title', 'Tytuł'],
  sku:         ['SKU'],

  // Traffic
  sessions:    ['Sessions - Total', 'Sessions : total', 'Sessions – Total'],
  sessionsPct: [
    'Pourcentage de sessions - Total',
    'Pourcentage de sessions : total',
    'Session percentage – Total',
  ],
  pageViews:   [
    'Vues de la page - Total',
    'Consultations de la page : total',
    'Page views – Total',
  ],
  pageViewsPct: [
    'Pourcentage de vues de la page - Total',
    'Pourcentage de consultations de la page : total',
    'Page views percentage – Total',
  ],
  buyBoxPct:   [
    "Pourcentage de l’offre en vedette (boîte d’achat)",
    "Pourcentage d’offre en vedette (boîte d’achat)",
    'Featured Offer (Buy Box) percentage',
  ],

  // Orders & units
  units:       ['Unités commandées', 'Units ordered', 'Zamówione jednostki'],
  unitsPct:    [
    "Pourcentage de session d’unité",
    "Pourcentage de session d'unités",
    'Unit Session Percentage',
  ],

  // Revenue
  sales:       [
    'Ventes de produits commandés',
    'Ordered Product Sales',
    'Ordered product sales',  // IE
    'Sprzedaż produktów',
  ],
  salesB2B:    ['Ventes de produits commandés — B2B'],

  // Order totals
  totalOrders: [
    'Total de produits commandés',
    "Total d’articles commandés",
    'Total order items',
    'Liczba zamówionych artykułów',
  ],
};

/**
 * Returns the value of the first matching column key found in row,
 * or undefined if none match.
 */
export const getColumn = (row, fieldName) => {
  if (!row) return undefined;
  const keys = COLUMN_MAPPING[fieldName];
  if (!keys) return undefined;
  for (const key of keys) {
    if (row[key] !== undefined && row[key] !== null) return row[key];
  }
  return undefined;
};

/**
 * Like getColumn but searches all COLUMN_MAPPING entries for a key
 * that exists in the row and returns { fieldName, value }.
 * Useful for auto-detecting which locale a CSV uses.
 */
export const detectLocale = (row) => {
  const matched = {};
  for (const [field, keys] of Object.entries(COLUMN_MAPPING)) {
    for (const key of keys) {
      if (row[key] !== undefined) {
        matched[field] = key;
        break;
      }
    }
  }
  return matched;
};
